import type { Href } from 'expo-router';

/**
 * Returns the bare path portion of an Href — strips any `?query` and
 * handles the object form. Comparisons against `usePathname()` and lookups
 * against `ONBOARDING_STEP_GROUPS` always want the bare path, not the full
 * Href, which may carry an `?org=` param (see `resolveOnboardingRoute` for
 * the org-required routes that emit those).
 */
export function hrefPathname(href: Href | null | undefined): string | null {
  if (!href) return null;
  if (typeof href === 'string') {
    const idx = href.indexOf('?');
    return idx >= 0 ? href.slice(0, idx) : href;
  }
  return href.pathname ?? null;
}
